import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    observer: { type: Boolean, default: false }
  }

  connect() {
    this.scrollContainer = this.element.closest('[id*="messages"]')
    this.userHasScrolled = false
    this.scrollToBottom()

    if (this.observerValue) {
      this.observer = new MutationObserver(() => this.scrollToBottom());
      this.observer.observe(this.element, { childList: true });
    }

  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  scrollToBottom() {
    if (!this.userHasScrolled) {
      this.scrollContainer.scrollTop = this.scrollContainer.scrollHeight
    }
  }

  trackUserScroll() {
    const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer
    this.userHasScrolled = (scrollHeight - scrollTop - clientHeight) > 10
  }
}
